export default {
  saturationCurves: 'Curvas de Saturação',
  generalView: 'Visão Geral',
  optimalZones: 'Zonas Ótimas',
  noOptimalZonesData: '{name} não inclui dados de Zonas Ótimas.',
  marginalRoas: 'Marginal ROAS',
  showHistoricalSpend: 'Pontos de gasto histórico',
  showSpend: 'Pontos de gasto',
  exportCurves: 'Exportar curvas',
  spendUnit: 'Unidade de Gasto',
  spend: 'Gasto',
  monthly: 'Mensal',
  weekly: 'Semanal',
  quarterly: 'Trimestral',
  yearly: 'Anual',
  monthlyAvg: 'Média Mensal',
  quarterlyAvg: 'Média Trimestral',
  yearlyAvg: 'Média Anual',
  none: 'Nenhum',
  ok: 'Ok',
  cancel: 'Cancelar',
  save: 'Salvar',
  aboutOptimalZones: 'Sobre as Zonas Ótimas',
  zone1: 'Zona 1',
  zone1Desc: 'Esta faixa geralmente deve ser evitada, pois está abaixo do Limite Mínimo de Gasto, resultando em contribuições insignificantes. Qualquer dólar gasto nesta zona é essencialmente desperdiçado.',
  zone2: 'Zona 2',
  zone2Desc: 'Nesta faixa, os dólares gastos começam a mostrar uma contribuição marginal pequena mas de rápido crescimento. Tipicamente, pequenos incrementos no gasto geram altos ganhos em contribuição marginal, até o ponto onde a Contribuição Marginal Máxima é alcançada.',
  zone3: 'Zona 3',
  zone3Desc: 'Esta faixa, junto com a próxima, geralmente é considerada "ótima". À medida que o gasto aumenta nesta faixa, a contribuição marginal de cada dólar adicional gasto diminui gradualmente, embora o Retorno sobre Investimento em Publicidade (ROAS) de cada dólar continue crescendo.',
  zone4: 'Zona 4',
  zone4Desc: 'Esta faixa, junto com a anterior, geralmente é considerada "ótima". No entanto, diferente da Zona 3, à medida que o gasto aumenta nesta faixa, o ROAS diminui gradualmente, tornando o gasto adicional cada vez menos eficiente.',
  zone5: 'Zona 5',
  zone5Desc: 'Similar à Zona 1, esta faixa geralmente deve ser evitada, pois representa gasto além do eficiente. Nesta zona, a contribuição de cada dólar adicional é tão pequena que é essencialmente um desperdício de recursos.',
  aboutMarginalRoas: 'Sobre o Marginal ROAS',
  marginalRoasDesc: 'O Marginal ROAS (mROAS) é o retorno incremental gerado por cada unidade adicional de investimento, ou seja, a inclinação (derivada) da curva de saturação. Cada gráfico sobrepõe a curva de saturação (eixo esquerdo) à sua curva marginal (eixo direito): o valor marginal em um determinado nível de investimento é a diferença de contribuição incremental dividida pela diferença de investimento entre esse nível e o anterior.',
  averageCpi: 'CPI Médio',
  enterCpiInstructions: 'Digite o Custo Por Impressão médio (MXN) para cada canal de mídia:',
  editAverageCpi: 'Editar Custo Por Impressão Médio'
}
